<template>
  <v-dialog :value="visible" @input="$emit('update:visible', false)" max-width="600px" persistent>
    <v-card dark v-if="visible">
      <v-card-title class="text-h5 primary white--text"> Studio-Einstellungen kopieren </v-card-title>
      <v-card-text class="mt-4">
        <p class="white--text">
          Wählen Sie ein Quellstudio, dessen Einstellungen (inkl. Preise für Mitgliedschaften und Pakete) auf ein Zielstudio kopiert werden sollen.
        </p>
        <v-select
          :items="studios"
          item-text="name"
          item-value="_id"
          label="Quelle (Einstellungen von diesem Studio kopieren)"
          v-model="fromStudioId"
          outlined
          dense
          class="mb-4"></v-select>

        <v-select
          :items="destinationStudios"
          item-text="name"
          item-value="_id"
          label="Ziel (Einstellungen in dieses Studio einfügen)"
          v-model="toStudioId"
          outlined
          dense></v-select>

        <v-alert type="warning" dense text class="mt-4">
          Achtung: Dieser Vorgang fügt das Zielstudio zu allen Vertragspartnern, Kategorien, Mitgliedschaften und Paketen hinzu, die dem Quellstudio
          zugewiesen sind. Bestehende Einstellungen im Zielstudio werden nicht gelöscht, aber möglicherweise überschrieben, falls sie bereits
          existieren.
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('update:visible', false)">Abbrechen</v-btn>
        <v-btn color="primary" :disabled="!fromStudioId || !toStudioId" @click="confirmCopy"> Kopieren </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CopySettingsDialog",
  props: {
    visible: Boolean,
    studios: Array,
  },
  data() {
    return {
      fromStudioId: null,
      toStudioId: null,
    }
  },
  computed: {
    destinationStudios() {
      if (!this.fromStudioId) {
        return this.studios
      }
      // Verhindert, dass Quelle und Ziel identisch sind
      return this.studios.filter((s) => s._id !== this.fromStudioId)
    },
  },
  methods: {
    confirmCopy() {
      this.$emit("copy", { fromStudioId: this.fromStudioId, toStudioId: this.toStudioId })
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.fromStudioId = null
        this.toStudioId = null
      }
    },
  },
}
</script>
